require 'angular'

angular.module('workflow.app')
  .controller('PreferencesWorkflowEditController', require './PreferencesWorkflowEditController')
  .controller('CustomStepModalController', require './CustomStepModal/CustomStepModalController')

require('./stepConfigSourceList')
require('./StepTemplate')
